import { combineReducers } from 'redux';
import accountReducer from './accountReducer';
import notificationsReducer from './notificationsReducer';
import chatReducer from './chatReducer';
import mailReducer from './mailReducer';
import kanbanReducer from './kanbanReducer';
import dashboardReducer from './dashboardReducer';
import objectReducer from './objectReducer';
import faultyCountReducer from './faultyCountReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  notifications: notificationsReducer,
  chat: chatReducer,
  mail: mailReducer,
  kanban: kanbanReducer,
  dashboard: dashboardReducer,
  objects: objectReducer,
  faultyCount: faultyCountReducer
});

export default rootReducer;
